import {jsonMember, jsonObject} from "typedjson";
import {DxControlPointPattern} from "./dx-control-point-pattern";
import {DxGridRow} from "../../../dx-grid/domain/dx-grid-row";
import * as moment from "moment";
import 'moment-duration-format';

@jsonObject()
export class DxControlPointInstance extends DxGridRow {

  /**
   *  Фактическая дата прохождения контрольной точки.
   */
  @jsonMember({constructor: Date, isRequired: false})
  actualPassageDate: Date;

  /**
   * Идентифкатор экземпляра цепочки КТ, в которую входит данный экемпляр КТ.
   */
  @jsonMember({constructor: Number, isRequired: true})
  chainInstanceId: number;

  /**
   * Строковый код: экземпляра контрольной точки \ цепочки контрольных точек: ЦКТ10 (например).
   */
  @jsonMember({constructor: String, isRequired: true})
  code: string;

  /**
   * Идентификатор.
   */
  @jsonMember({constructor: Number, isRequired: true})
  id: number;

  /**
   * Наименование экземпляра контрольной точки \ цепочки контрольных точек.
   */
  @jsonMember({constructor: String, isRequired: true})
  name: string;

  @jsonMember({constructor: DxControlPointPattern, isRequired: true})
  pattern: DxControlPointPattern;

  /**
   * Плановая дата прохождения контрольной точки (вычислимая величина).
   */
  @jsonMember({constructor: Date, isRequired: true})
  plannedPassageDate: Date;

  /**
   * Электронная почта отвесвенного по контрольной точке лица.
   */
  @jsonMember({constructor: String, isRequired: true})
  responsibleEmail: string;

  /**
   * Id отвесвенного по контрольной точке лица.
   */
  @jsonMember({constructor: Number, isRequired: true})
  responsibleId: number;

  @jsonMember({constructor: String, isRequired: false})
  responsibleLogin:	string;

  @jsonMember({constructor: String, isRequired: false})
  responsibleName: string;

  @jsonMember({constructor: String, isRequired: false})
  responsiblePosition: string;

  /**
   * ВНИМАНИЕ!!! Тонкий момент. Так как последовательность контрольных точек в цепочке и их расположение (проекция )
   * на оси времени могут различаться, то необходимо (чтоб постоянно не сортироват по датам) хранить текущий порядок
   * следования КТ на оси врменени. Он будет меняться при выпонении перераспределения КТ. Данный порядок не является
   * сквозным отноительно всей таблицы, а определен лишь в рамках набора точек для одного инстанса цепочки.
   */
  @jsonMember({constructor: Number, isRequired: false})
  timeFlowOrd: number;


  getRowId(): number {
    return this.id;
  }

}
